export default "__VITE_ASSET__Cau8PI6j__"